module.exports = __webpack_public_path__ + "img/5.bea9517.png";